import src from "IMAGE";
export default { src, width: 3764, height: 936, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPUlEQVR42g3CSw5AEQwFUJvTxxZ4xcQnKUlr/wP35DhP5FVNS61FZEuHlHMac44PHIHdaw1+ZmQ+sCDEGB4GThdtNnwt+AAAAABJRU5ErkJggg=="};
